
export default (word, val1, val2, val3) => {
  const language = localStorage.getItem('currentLanguage')?.substring(0, 2) || window.serverdata.configMeta.aim.lang || 'nb';

  const translation = window.translation;

  if (translation !== 'undefined') {
    if (translation) {
      if (translation[language]) {
        if (translation[language][word]) {
          return translation[language][word].replace('REPLACEVAL1', val1).replace('REPLACEVAL2', val2).replace('REPLACEVAL3', val3);
        }
        if (translation.nb[word]) {
          return translation.nb[word];
        }
        return word;
      }
      return word;
    }
    return word;
  }
  return word;
};
